/* eslint-disable @typescript-eslint/no-explicit-any */
export enum CookieNameEnum {
  acceptCookie = 'accept_cookie',
  cookiesPromt = 'cookies_promt',
}

/**
 * @category Utils
 */
export function checkDocumentExist() {
  return typeof document === 'object';
}

/**
 * @category Utils
 */
export function getCookie(name: string) {
  const matches = document.cookie.match(
    // eslint-disable-next-line no-useless-escape
    new RegExp(`(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

/**
 * @category Utils
 */
export function setCookie(name: string, value: any, options: any = {}) {
  options = {
    path: '/',
    ...options,
  };

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  for (const optionKey in options) {
    updatedCookie += `; ${optionKey}`;
    const optionValue = options[optionKey];
    if (optionValue) {
      updatedCookie += `=${optionValue}`;
    }
  }

  document.cookie = updatedCookie;
}
